import { Controller } from "@hotwired/stimulus";
import mapboxgl, { Marker } from "mapbox-gl";

export default class extends Controller {
  static values = {
    lat: String,
    lng: String,
    color: String,
  };
  static targets = ["map", "marker"];

  connect() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";
    this.initMap();
  }

  initMap() {
    const latLng = { lat: this.latValue, lng: this.lngValue };
    const color = this.colorValue;
    const params = {
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      attributionControl: false,
      logoPosition: "bottom-right",
      center: latLng,
      zoom: 14,
    };

    const map = new mapboxgl.Map(params);
    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );

    new Marker({
      draggable: false,
      color: `#${color}`,
    })
      .setLngLat(latLng)
      .addTo(map);

    map.on("load", function () {
      map.resize();
    });

    this.map = map;
  }
}
